// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Settings_root_WZwG5{padding:64px}.Settings_title_7alkV{font-size:28px;font-weight:700;color:#313a46;margin:0 0 64px 0}.Settings_section_6SvQS{margin-bottom:64px}.Settings_sectionTitle_3xy0X{font-size:18px;font-weight:600;color:#313a46;margin:0 0 32px 0}.Settings_form_1BstP{max-width:400px}.Settings_formItem_27dvC{margin-bottom:24px}.Settings_actions_1O3Ql{margin-top:32px}", ""]);
// Exports
exports.locals = {
	"root": "Settings_root_WZwG5",
	"title": "Settings_title_7alkV",
	"section": "Settings_section_6SvQS",
	"sectionTitle": "Settings_sectionTitle_3xy0X",
	"form": "Settings_form_1BstP",
	"formItem": "Settings_formItem_27dvC",
	"actions": "Settings_actions_1O3Ql"
};
module.exports = exports;
